module.exports = __webpack_public_path__ + "img/austinv.b82dc328.jpg";